import React from 'react';
import { ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { CHART_COLORS } from '../constants';
import PropTypes from 'prop-types';

const WeeklyPerformanceChart = ({ data }) => {
    if (!data) return null;

    return (
        <div className="chart-container weekly-performance-chart">
            <h3>Weekly Performance</h3>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke={CHART_COLORS.grid}
                    />
                    <XAxis
                        dataKey="week_number"
                        stroke={CHART_COLORS.text}
                    />
                    <YAxis stroke={CHART_COLORS.text} />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: CHART_COLORS.background,
                            border: `1px solid ${CHART_COLORS.grid}`
                        }}
                    />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey="avg_margin"
                        stroke={CHART_COLORS.primary}
                        name="Avg Margin"
                    />
                    <Line
                        type="monotone"
                        dataKey="wins"
                        stroke={CHART_COLORS.secondary}
                        name="Wins"
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

WeeklyPerformanceChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        week_number: PropTypes.number.isRequired,
        avg_margin: PropTypes.number.isRequired,
        wins: PropTypes.number.isRequired
    })).isRequired
};

export default WeeklyPerformanceChart;
